export const ko = {
  // Common
  "app.name": "ooo.codes",
  "app.subtitle": "URL 단축 & QR 생성기",
  "common.loading": "로딩 중...",
  "common.cancel": "취소",
  "common.save": "저장",
  "common.delete": "삭제",
  "common.copy": "복사",
  "common.copied": "복사됨",

  // Login
  "login.title": "패스키로 로그인",
  "login.button": "패스키로 로그인",
  "login.authenticating": "인증 중...",
  "login.passkey_info": "이 서비스는 패스키(WebAuthn)를 통한 비밀번호 없는 인증을 사용합니다.",
  "login.first_time": "처음이신가요? 계정을 설정하세요",
  "login.have_invite": "초대 코드가 있으신가요?",
  "login.invite_placeholder": "초대 코드를 입력하세요",
  "login.join": "참여",
  "login.back_to_login": "로그인으로 돌아가기",
  "login.auth_cancelled": "인증이 취소되었거나 허용되지 않았습니다.",
  "login.failed": "로그인에 실패했습니다",
  "login.or": "또는",
  "login.signup_button": "신규 가입",
  "login.signup_title": "신규 계정 만들기",
  "login.signup_subtitle": "패스키로 간편하게 가입하세요.",
  "login.usage_today": "오늘의 요청",
  "login.used": "사용",
  "login.pending_approval": "관리자 승인 대기 중입니다. 승인 후 로그인할 수 있습니다.",
  "login.account_suspended": "계정이 일시 정지되었습니다. 관리자에게 문의하세요.",
  "login.account_banned": "계정이 차단되었습니다.",
  "login.signup_success": "가입이 완료되었습니다! 관리자 승인 후 로그인할 수 있습니다.",

  // Setup
  "setup.title": "환영합니다! 계정을 설정하세요",
  "setup.subtitle": "시작하려면 소유자 계정을 만드세요.",
  "setup.username": "사용자명",
  "setup.display_name": "표시 이름",
  "setup.button": "패스키로 계정 만들기",
  "setup.setting_up": "설정 중...",
  "setup.already_have_account": "이미 계정이 있으신가요? 로그인",
  "setup.cancelled": "등록이 취소되었거나 허용되지 않았습니다.",
  "setup.failed": "설정에 실패했습니다",

  // Invite
  "invite.verifying": "초대장 확인 중...",
  "invite.invalid_title": "유효하지 않거나 만료된 초대장",
  "invite.invalid_message": "이 초대 링크는 더 이상 유효하지 않습니다. 관리자에게 새 초대를 요청하세요.",
  "invite.invited": "초대되었습니다",
  "invite.create_account": "계정 만들기",
  "invite.for": "초대 대상:",
  "invite.username": "사용자명",
  "invite.username_placeholder": "사용자명을 선택하세요",
  "invite.display_name": "표시 이름",
  "invite.display_name_placeholder": "이름을 입력하세요",
  "invite.button": "패스키로 계정 만들기",
  "invite.setting_up": "설정 중...",
  "invite.passkey_info": "비밀번호 없는 인증을 위한 패스키를 만들라는 안내가 표시됩니다.",
  "invite.cancelled": "등록이 취소되었거나 허용되지 않았습니다.",
  "invite.failed": "등록에 실패했습니다",

  // Invitations
  "invitations.title": "초대 관리",
  "invitations.send": "초대 보내기",
  "invitations.email_placeholder": "이메일 주소를 입력하세요",
  "invitations.send_button": "초대 보내기",
  "invitations.sending": "보내는 중...",
  "invitations.list_title": "초대 목록",
  "invitations.empty": "아직 보낸 초대가 없습니다.",
  "invitations.status_pending": "대기중",
  "invitations.status_accepted": "수락됨",
  "invitations.status_expired": "만료됨",
  "invitations.copy_link": "링크 복사",
  "invitations.revoke": "취소",
  "invitations.revoke_confirm": "이 초대를 취소하시겠습니까?",
  "invitations.created": "생성일",
  "invitations.expires": "만료일",
  "invitations.owner_only": "초대 관리는 소유자만 사용할 수 있습니다.",

  // Create Link
  "create.advanced_settings": "고급 설정",
  "create.qr_preview": "QR 코드 미리보기",
  "create.default_expiry_info": "기본 유효기간: 7일",
  "create.title_tooltip": "링크 목록에서 쉽게 구분할 수 있는 이름입니다.",
  "create.slug_tooltip": "ooo.codes/ 뒤에 붙는 짧은 주소를 직접 지정합니다. 비워두면 자동 생성됩니다.",
  "create.expires_tooltip": "이 날짜가 지나면 링크가 비활성화됩니다. 최대 30일까지 설정 가능합니다.",
  "create.expires_max_30": "최대 30일까지 설정할 수 있습니다.",

  // Navigation
  "nav.dashboard": "대시보드",
  "nav.create_link": "링크 만들기",
  "nav.invitations": "초대 관리",
  "nav.settings": "설정",
  "nav.logout": "로그아웃",
  "nav.signed_in_as": "로그인:",
  "nav.toggle_menu": "메뉴 토글",
  "nav.toggle_theme": "테마 토글",

  // Dashboard
  "dashboard.title": "내 링크",
  "dashboard.search": "링크 검색...",
  "dashboard.create_link": "링크 만들기",
  "dashboard.loading": "링크 로딩 중...",
  "dashboard.no_results": "일치하는 링크 없음:",
  "dashboard.empty": "아직 링크가 없습니다. 첫 번째 단축 링크를 만들어 보세요!",
  "dashboard.clicks": "클릭",
  "dashboard.inactive": "비활성",
  "dashboard.previous": "이전",
  "dashboard.next": "다음",
  "dashboard.page_of": "페이지 {page} / {total}",
  "dashboard.copy_url": "단축 URL 복사",

  // Create Link
  "create.title": "단축 링크 만들기",
  "create.url_label": "대상 URL *",
  "create.custom_slug": "커스텀 주소",
  "create.slug_invalid": "문자, 숫자, 하이픈, 밑줄만 사용할 수 있습니다.",
  "create.slug_taken": "이 슬러그는 이미 사용 중입니다.",
  "create.slug_available": "이 슬러그를 사용할 수 있습니다!",
  "create.slug_auto": "랜덤 슬러그가 자동 생성됩니다.",
  "create.title_label": "제목",
  "create.expires_label": "만료일",
  "create.remove_expiration": "만료일 제거",
  "create.preview": "미리보기",
  "create.button": "단축 링크 만들기",
  "create.creating": "생성 중...",
  "create.failed": "링크 생성에 실패했습니다",

  // Link Detail
  "detail.loading": "로딩 중...",
  "detail.not_found": "링크를 찾을 수 없습니다",
  "detail.back": "대시보드로 돌아가기",
  "detail.inactive": "비활성",
  "detail.analytics": "분석",
  "detail.edit": "편집",
  "detail.cancel": "취소",
  "detail.delete": "삭제",
  "detail.confirm_delete": "정말 삭제하시겠습니까?",
  "detail.yes_delete": "예, 삭제",
  "detail.no": "아니오",
  "detail.short_url": "단축 URL",
  "detail.destination": "대상 URL",
  "detail.clicks": "클릭 수",
  "detail.created": "생성일",
  "detail.expires": "만료일",
  "detail.status": "상태",
  "detail.active": "활성",
  "detail.edit_link": "링크 편집",
  "detail.destination_url": "대상 URL",
  "detail.title_label": "제목",
  "detail.expires_at": "만료일",
  "detail.remove_expiration": "만료일 제거",
  "detail.active_toggle": "활성",
  "detail.save_changes": "변경사항 저장",
  "detail.saving": "저장 중...",
  "detail.update_failed": "링크 업데이트에 실패했습니다",
  "detail.copy_tooltip": "클립보드에 복사",

  // Analytics
  "analytics.title": "분석",
  "analytics.loading": "분석 데이터 로딩 중...",
  "analytics.no_data": "분석 데이터가 없습니다.",
  "analytics.last_7": "최근 7일",
  "analytics.last_30": "최근 30일",
  "analytics.last_90": "최근 90일",
  "analytics.total_clicks": "전체 클릭",
  "analytics.today": "오늘",
  "analytics.this_week": "이번 주",
  "analytics.this_month": "이번 달",
  "analytics.over_time": "시간별 클릭 수",
  "analytics.referrers": "주요 리퍼러",
  "analytics.countries": "주요 국가",
  "analytics.devices": "기기",
  "analytics.browsers": "브라우저",
  "analytics.empty": "아직 클릭 데이터가 없습니다. 링크를 공유하여 분석을 시작하세요.",

  // Settings
  "settings.title": "설정",
  "settings.account": "계정",
  "settings.username": "사용자명",
  "settings.display_name": "표시 이름",
  "settings.role": "역할",
  "settings.member_since": "가입일",
  "settings.api_keys": "API 키",
  "settings.api_keys_desc": "ooo.codes API에 프로그래밍 방식으로 접근하기 위한 API 키를 생성하세요.",
  "settings.key_placeholder": "키 이름 (예: CI/CD 파이프라인)",
  "settings.create_key": "키 생성",
  "settings.key_created": "API 키가 생성되었습니다! 지금 복사하세요 — 다시 표시되지 않습니다.",
  "settings.no_keys": "아직 API 키가 없습니다.",
  "settings.revoke": "해지",
  "settings.created": "생성",
  "settings.last_used": "마지막 사용",
  "settings.invite_user": "사용자 초대",
  "settings.invite_desc": "다른 사람이 계정을 만들 수 있도록 초대를 보내세요.",
  "settings.send_invite": "초대 보내기",
  "settings.invite_created": "초대가 생성되었습니다! 이 링크를 공유하세요:",
  "settings.create_key_failed": "API 키 생성에 실패했습니다",
  "settings.revoke_failed": "키 해지에 실패했습니다",
  "settings.invite_failed": "초대 전송에 실패했습니다",

  // QR Customizer
  "qr.title": "QR 코드",
  "qr.foreground": "전경색",
  "qr.background": "배경색",
  "qr.size": "크기",
  "qr.error_correction": "오류 정정",
  "qr.ec_low": "낮음",
  "qr.ec_med": "중간",
  "qr.ec_high": "높음",
  "qr.ec_max": "최대",
  "qr.ec_info": "높은 정정 수준은 QR 코드가 부분적으로 손상되어도 스캔할 수 있게 합니다.",
  "qr.save": "설정 저장",
  "qr.saving": "저장 중...",
  "qr.saved": "저장됨!",
  // Admin
  "admin.title": "관리 콘솔",
  "admin.dashboard": "대시보드",
  "admin.users": "회원 관리",
  "admin.stats": "통계",
  "admin.total_users": "전체 회원",
  "admin.active_users": "활성 회원",
  "admin.pending_users": "승인 대기",
  "admin.total_links": "전체 링크",
  "admin.total_clicks": "전체 클릭",
  "admin.today_signups": "오늘 가입",
  "admin.user_detail": "회원 상세",
  "admin.status_pending": "대기",
  "admin.status_active": "활성",
  "admin.status_suspended": "정지",
  "admin.status_banned": "차단",
  "admin.approve": "승인",
  "admin.reject": "거절",
  "admin.suspend": "정지",
  "admin.ban": "차단",
  "admin.activate": "활성화",
  "admin.daily_limit": "일별 링크 제한",
  "admin.daily_limit_unlimited": "무제한",
  "admin.links_today": "오늘 생성 링크",
  "admin.status_reason": "사유",
  "admin.status_reason_placeholder": "정지/차단 사유를 입력하세요",
  "admin.confirm_suspend": "이 회원을 정지하시겠습니까?",
  "admin.confirm_ban": "이 회원을 영구 차단하시겠습니까?",
  "admin.link_count": "링크 수",
  "admin.member_since": "가입일",
  "admin.role": "역할",
  "admin.status": "상태",
  "admin.actions": "관리",
  "admin.no_users": "회원이 없습니다.",
  "admin.all": "전체",
  "admin.filter_status": "상태 필터",
  "admin.back": "목록으로",
  "admin.save_limit": "저장",
  "admin.console": "관리",
  "admin.role_owner": "소유자",
  "admin.role_member": "멤버",
  "admin.change_role": "역할 변경",
  "admin.confirm_role_change": "역할을 변경하시겠습니까?",
} as const;

export type TranslationKey = keyof typeof ko;
